var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"lib-common-model-scroll",staticClass:"lib-common-model-scroll",on:{"touchstart":_vm.touchstart,"touchmove":_vm.touchmove,"scroll":_vm.scroll}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }